// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import vSelect from 'vue-select'
import App from './App'
import axios from 'axios'
import auth from './auth'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader

Vue.use(Vuetify)
Vue.component('v-select', vSelect)

Vue.config.productionTip = false

auth.checkAuth()
axios.defaults.headers.common['Authorization'] = `Basic ${auth.getAuthToken()}`

Vue.prototype.$auth = auth
Vue.prototype.$axios = axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js